import Styles from './DesignContent.module.scss'
import cx from 'classnames'
import { useRef } from 'react'
import { useHover } from '@react-aria/interactions'
import { StoreSnapshot } from '@tldraw/tldraw'
import { Button } from 'blaze-ui/Button'
import { DesignContentPreview } from 'components/DesignContentPreview/DesignContentPreview'
import { EyeOpen, ImageAdd } from 'blaze-ui/icons'
import { DesignPreviewModal } from './DesignPreviewModal'
import { useModals } from 'almanac-ui/Modal'
import { useButton } from '@react-aria/button'
import { mergeProps } from '@react-aria/utils'
import { useApplyDesign } from 'components/ChatAssistant/useApplyDesign'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

interface DesignPreviewProps {
  option: number
  content: Array<StoreSnapshot<any>>
  width: number
  height: number
  designId: string
}

export const DesignPreview = ({ option, content, width, height, designId }: DesignPreviewProps) => {
  const { openModal } = useModals()
  const ref = useRef<HTMLDivElement>(null)
  const isChatV2 = useFlipperFlag('chat_v2')
  const { isHovered, hoverProps } = useHover({})
  const { applyDesign } = useApplyDesign({ fileId: designId })
  const aspectRatio = width / height
  const isLandscape = width > height

  const handleOpenDesignPreviewModal = () => {
    openModal(
      DesignPreviewModal,
      {
        initialOption: option,
        content,
        aspectRatio,
        onUseDesign: applyDesign,
      },
      { newStack: true },
    )
  }

  const { buttonProps } = useButton({ onPress: handleOpenDesignPreviewModal, elementType: 'div' }, ref)

  return (
    <div
      className={cx(Styles.designPreview, { [Styles.landscape]: isLandscape })}
      style={{ aspectRatio }}
      data-testid={`design-preview-item-${option}`}
      ref={ref}
      {...(isChatV2 ? buttonProps : mergeProps(hoverProps, buttonProps))}
    >
      <DesignContentPreview content={content[option]} />
      {!isChatV2 && isHovered && (
        <div className={Styles.designPreviewOverlay}>
          <Button size="xs" variant="primary" frontIcon={EyeOpen} onPress={handleOpenDesignPreviewModal}>
            Preview
          </Button>
          <div className={Styles.insertButtonContainer}>
            <Button size="xs" variant="secondary" frontIcon={ImageAdd} onPress={() => applyDesign(content[option])}>
              Insert
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
